import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { IApproverTimeOff, ITimeOff } from './interface';
import { inject, Injectable } from '@angular/core';
import {
    CreateTimeOff,
    GetAllRequests,
    GetSingleTimeOff,
    GetTimeOffsByApprovers,
    GetTimeOffsByUser
} from './action';
import { catchError, tap } from 'rxjs';
import { TimeOffService } from './time-off.service';

export class IProps {
    timeOffs!: ITimeOff[];

    timeOff!: ITimeOff | null;
    approversRes!: IApproverTimeOff[];
    loadingSingle!: boolean;
    loading!: boolean;
    error!: string | null;
}

@State<IProps>({
    name: 'timeoff',
    defaults: {
        timeOffs: [],
        approversRes: [],
        timeOff: null,

        loadingSingle: false,
        loading: false,
        error: null
    }
})
@Injectable()
export class TimeOffStore {
    requestsService: TimeOffService = inject(TimeOffService);
    private store: Store = inject(Store);

    @Selector()
    static getTimeOffs(state: IProps) {
        return state.timeOffs;
    }
    @Selector()
    static getApproverTimeOffs(state: IProps) {
        return state.approversRes;
    }
    @Selector()
    static singleTimeOff(state: IProps) {
        return state.timeOff;
    }

    @Selector()
    static getUserTimeOffs(state: IProps) {
        return state.timeOffs;
    }

    @Selector()
    static loading(state: IProps) {
        return state.loading;
    }

    @Action(GetAllRequests)
    getAllRequest(ctx: StateContext<IProps>, action: GetAllRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getTimeOffRequests(action.queryParams as any).pipe(
            tap((res) => {
                ctx.patchState({
                    timeOffs: res,
                    loading: false,
                    error: null
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(CreateTimeOff)
    createTimeOff(ctx: StateContext<IProps>, action: CreateTimeOff) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.createTimeOff(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    timeOffs: [...state.timeOffs, res],
                    timeOff: res,

                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    error: err.message,
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(GetSingleTimeOff)
    getOneRequest(ctx: StateContext<IProps>, action: GetSingleTimeOff) {
        const state = ctx.getState();
        ctx.patchState({ loadingSingle: true });

        return this.requestsService.getSingle(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    timeOff: res,
                    loadingSingle: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loadingSingle: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetTimeOffsByUser)
    getByUser(ctx: StateContext<IProps>, action: GetTimeOffsByUser) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getTimeOffBysUser(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    timeOffs: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetTimeOffsByApprovers)
    getByApprovers(ctx: StateContext<IProps>, action: GetTimeOffsByApprovers) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getTimeOffByApproverRequests(action.input).pipe(
            tap((res: IApproverTimeOff[]) => {
                ctx.patchState({
                    approversRes: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
}
